import { MenuItem } from '../models/menu/menu.model';
import { ROUTE_IDENTIFIER_NAMES } from '../models/route-identifiers/route-identifiers.model';
import { SECURITY_ROLE_KEY } from '../models/security/security-role-keys';

export const gmcaMenu: MenuItem[] = [
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.COMPETENCY_CLAIMS,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.COMPETENCY_ASSESSMENTS,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.MATRICES,
    securityRoles: SECURITY_ROLE_KEY.User,
    subMenu: [
      {
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS_COMPETENCY_MATRIX,
        hideItem: true,
        securityRoles: [],
      },
    ],
  },

  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS,
    securityRoles: SECURITY_ROLE_KEY.User,
    subMenu: [
      {
        routeIdentifier:
          ROUTE_IDENTIFIER_NAMES.ANALYSIS_TRAINING_MATRIX_SUMMARY,
        allowManagementPositionAccess: true,
        securityRoles: SECURITY_ROLE_KEY.OuResponsible,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_COMPETENCY_LIBRARY,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_LEVEL_GROUP_LIBRARY,
        hideItem: true,
      },
    ],
  },
];
